import { purgeLegacyStorageKeys } from "@/lib/legacyStorageCleanup";

// IMPORTANT: this MUST run before any module that transitively imports a
// Zustand store. Stores call create() at import time, and the persist
// middleware reads localStorage during that synchronous init. Clearing the
// legacy keys after stores have already loaded them would defeat the purpose.
//
// To guarantee the order we (a) call purge synchronously at module top, then
// (b) load React + Router via dynamic imports inside an async IIFE. The build
// target is es2020 (no top-level await), so the IIFE is the portable shape.
purgeLegacyStorageKeys();

void (async () => {
  const { startTransition, StrictMode } = await import("react");
  const { hydrateRoot } = await import("react-dom/client");
  const { HydratedRouter } = await import("react-router/dom");

  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter />
      </StrictMode>,
    );
  });
})();
